import type {
  CreateProjectChangeAdoptionItemDto,
  PortfolioDto,
  ProjectChangeAdoptionItemDto,
  ProjectLogItemDto,
  ProjectManagementProductDto,
  UpdateProjectChangeAdoptionItemDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const portfolioQueryKey = ['portfolio'] as const;
export const managementProductsQueryKey = (projectId: string) => ['managementProducts', projectId] as const;
export const projectLogQueryKey = (projectId: string) => ['projectLog', projectId] as const;
export const changeAdoptionQueryKey = (projectId: string) => ['changeAdoption', projectId] as const;

export const projectPortfolioApi = {
  async get(): Promise<PortfolioDto> {
    return API.get<PortfolioDto>('/portfolio').then((res) => res.data);
  },
  async exportPdf(): Promise<Blob> {
    return API.get('/portfolio.pdf', { responseType: 'blob' }).then((res) => res.data);
  },
  async listProducts(projectId: string): Promise<ProjectManagementProductDto[]> {
    return API.get<ProjectManagementProductDto[]>(
      `/projects/${encodeURIComponent(projectId)}/management-products`,
    ).then((res) => res.data);
  },
  async downloadProductPdf(projectId: string, productId: string): Promise<Blob> {
    return API.get(
      `/projects/${encodeURIComponent(projectId)}/management-products/${encodeURIComponent(productId)}/pdf`,
      { responseType: 'blob' },
    ).then((res) => res.data);
  },
  async listLog(projectId: string): Promise<ProjectLogItemDto[]> {
    return API.get<ProjectLogItemDto[]>(`/projects/${encodeURIComponent(projectId)}/log`).then((res) => res.data);
  },
  async listAdoption(projectId: string): Promise<ProjectChangeAdoptionItemDto[]> {
    return API.get<ProjectChangeAdoptionItemDto[]>(
      `/projects/${encodeURIComponent(projectId)}/change-adoption`,
    ).then((res) => res.data);
  },
  async createAdoption(projectId: string, dto: CreateProjectChangeAdoptionItemDto): Promise<ProjectChangeAdoptionItemDto> {
    return API.post<ProjectChangeAdoptionItemDto>(
      `/projects/${encodeURIComponent(projectId)}/change-adoption`,
      dto,
      { headers: { 'Idempotency-Key': crypto.randomUUID() } },
    ).then((res) => res.data);
  },
  async updateAdoption(
    projectId: string,
    itemId: string,
    dto: UpdateProjectChangeAdoptionItemDto,
  ): Promise<ProjectChangeAdoptionItemDto> {
    return API.patch<ProjectChangeAdoptionItemDto>(
      `/projects/${encodeURIComponent(projectId)}/change-adoption/${encodeURIComponent(itemId)}`,
      dto,
      { headers: { 'Idempotency-Key': crypto.randomUUID() } },
    ).then((res) => res.data);
  },
};
